import { EventEmitter } from '@angular/core';
import { CommonService } from '../common.service';
function getPasswordRuleStatus(password) {
    var pwd = password || '';
    var hasUpper = /[A-Z]/.test(pwd);
    var hasLower = /[a-z]/.test(pwd);
    var hasDigit = /\d/.test(pwd);
    var hasSpecial = /[^A-Za-z0-9]/.test(pwd);
    var typeCount = [hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length;
    return {
        minLength: pwd.length >= 8,
        complexity: typeCount >= 3
    };
}
var ForceChangePasswordComponent = (function () {
    function ForceChangePasswordComponent(commonService) {
        this.commonService = commonService;
        /** 登录时输入的密码，预填当前密码 */
        this.defaultOldPassword = '';
        this.close = new EventEmitter();
        this.success = new EventEmitter();
        this.assetsRoute = '../../assets/';
        this.submitting = false;
        this.oldPwdVisible = false;
        this.newPwdVisible = false;
        this.confirmPwdVisible = false;
        this.form = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        };
        this.errors = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        };
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    }
    ForceChangePasswordComponent.prototype.ngOnInit = function () {
        if (this.defaultOldPassword) {
            this.form.oldPassword = this.defaultOldPassword;
        }
    };
    Object.defineProperty(ForceChangePasswordComponent.prototype, "canSubmit", {
        /** 三项齐全且新密码符合规则时才可提交 */
        get: function () {
            if (this.submitting) {
                return false;
            }
            var _a = this.form, oldPassword = _a.oldPassword, newPassword = _a.newPassword, confirmPassword = _a.confirmPassword;
            if (!oldPassword || !newPassword || !confirmPassword) {
                return false;
            }
            var status = getPasswordRuleStatus(newPassword);
            if (!status.minLength || !status.complexity) {
                return false;
            }
            if (newPassword === oldPassword) {
                return false;
            }
            if (confirmPassword !== newPassword) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    ForceChangePasswordComponent.prototype.hide = function () {
        this.close.emit();
    };
    ForceChangePasswordComponent.prototype.handleFormBlur = function () {
        window.scroll(0, 0);
    };
    ForceChangePasswordComponent.prototype.onNewPasswordInput = function () {
        this.validateNewPassword();
        if (this.form.confirmPassword) {
            this.validateConfirmPassword();
        }
    };
    ForceChangePasswordComponent.prototype.onConfirmPasswordInput = function () {
        this.validateConfirmPassword();
    };
    ForceChangePasswordComponent.prototype.validateOldPassword = function () {
        if (!this.form.oldPassword) {
            this.errors.oldPassword = '请输入当前密码';
            return false;
        }
        this.errors.oldPassword = '';
        return true;
    };
    ForceChangePasswordComponent.prototype.validateNewPassword = function () {
        if (!this.form.newPassword) {
            this.errors.newPassword = '请输入新密码';
            return false;
        }
        var status = getPasswordRuleStatus(this.form.newPassword);
        if (!status.minLength && !status.complexity) {
            this.errors.newPassword = '密码不符合安全要求，请输入8位以上且包含至少三种字符类型的密码';
            return false;
        }
        if (!status.minLength) {
            this.errors.newPassword = '密码长度不足，请输入8位以上密码';
            return false;
        }
        if (!status.complexity) {
            this.errors.newPassword = '密码复杂度不足，请至少包含大写字母、小写字母、数字、特殊字符中的三类';
            return false;
        }
        if (this.form.newPassword === this.form.oldPassword) {
            this.errors.newPassword = '新密码不能与当前密码相同';
            return false;
        }
        this.errors.newPassword = '';
        return true;
    };
    ForceChangePasswordComponent.prototype.validateConfirmPassword = function () {
        if (!this.form.confirmPassword) {
            this.errors.confirmPassword = '请再次输入新密码';
            return false;
        }
        if (this.form.confirmPassword !== this.form.newPassword) {
            this.errors.confirmPassword = '两次输入的新密码不一致';
            return false;
        }
        this.errors.confirmPassword = '';
        return true;
    };
    ForceChangePasswordComponent.prototype.submit = function () {
        if (!this.canSubmit || this.submitting) {
            return;
        }
        var oldValid = this.validateOldPassword();
        var newValid = this.validateNewPassword();
        var confirmValid = this.validateConfirmPassword();
        if (!oldValid || !newValid || !confirmValid) {
            return;
        }
        this.submitting = true;
        // 与登录一致：出站密码使用 encrypt，禁止明文传递
        this.success.emit({
            currentPassword: this.commonService.encrypt(this.form.oldPassword),
            newPassword: this.commonService.encrypt(this.form.newPassword),
            // 仅供本地更新表单，不用于接口传输
            plainNewPassword: this.form.newPassword
        });
    };
    /** 父组件改密失败时恢复可提交状态 */
    ForceChangePasswordComponent.prototype.resetSubmitting = function () {
        this.submitting = false;
    };
    return ForceChangePasswordComponent;
}());
export { ForceChangePasswordComponent };



// WEBPACK FOOTER //
// ./src/app/force-change-password/force-change-password.component.ts.pre-build-optimizer.js